import React from 'react';
import {useState} from '../../../utils/ReactUtils';
import SimpleDropdown from "../../UI/organisms/SimpleDropdown";
import SavedExportsService from "../../../services/SavedExportsService";
import {Button} from "@mui/material";
import CalcService from "../../../services/CalcService";
import {generateRerunExport,generateRerunDiffs,generateRerunNewCharges} from "../../../utils/ExportUtils";

const RerunPriorExports = () => {
  const [exportDates,setExportDates] = useState(null,'exportDates');
  const [selectedExportDate,setSelectedExportDate] = useState(null,'selectedExportDate');
  const [dataResult,setDataResult] = useState(null,'dataResult');
  const [isLoading,setIsLoading] = useState(true,'loading');
  const [isResultLoading,setIsResultLoading] = useState(false,'resultLoading');
  const [errorMessage,setErrorMessage] = useState(null,'errorMessage');

  // get export dates
  React.useEffect( () => {
    if (!isLoading) {
      return;
    }
    const getExportDatesCall = async () => {
      setIsLoading(true);
      const _data = (await SavedExportsService.get())['data'];
      // need to parse out just the dates, and then order by most-recent first
      const uniqueDates = [
        ...new Set(_data.map(item => item.generated_at.slice(0,10)))
      ].sort((a,b) => b.localeCompare(a)); // sort descending
      setExportDates(uniqueDates);
      setIsLoading(false);
    };
    getExportDatesCall().catch(error => console.error(error));
  }, [isLoading]);

  // generate reports
  React.useEffect( () => {
    if (!isResultLoading) {
      return;
    }
    const doCall = async () => {
      setDataResult(null);
      const payload = {
        dataset: 'rerunPriorExport',
        rerunExportDate: selectedExportDate,
      };
      const _data = (await CalcService.doCalculations(payload))['data'];
      const {startDate, endDate} = _data;
      const generateExport = (key, func) => {
        const data = _data[key];
        const version = _data['versions'][key];
        func(data, startDate, endDate, version);
      }
      generateExport('rerunResult', generateRerunExport);
      generateExport('differences', generateRerunDiffs);
      generateExport('newCharges',generateRerunNewCharges);
      setErrorMessage(null);
    }
    doCall().catch(error => {
      console.error(error);
      const msg = error.response?.data?.message ? error.response.data.message
        : error.message ? error.message : "Unknown error; Check logs for more details.";
      setErrorMessage(msg);
    }).finally(() => {setIsResultLoading(false)});
  }, [isResultLoading]);

  const handleDateSelection = (e) => {
    const date = e.target.value;
    setSelectedExportDate(date)
  };

  const handleSubmit = (e) => {
    setIsResultLoading(true);
  };

  const pageContent = isLoading || isResultLoading ? "Loading..." : (
    <div>
      <SimpleDropdown
        label="Select Prior Export Date"
        options={exportDates}
        value={selectedExportDate ?? exportDates[0]}
        onChange={handleDateSelection}
      />
      <Button variant="contained" onClick={handleSubmit}>
        Rerun
      </Button>
    </div>
  );


  return (
    <div>
      <h2>Rerun Prior Exports</h2>
      {pageContent}
      {errorMessage}
    </div>
  );
}

export default RerunPriorExports;